<template>
  <v-app>
    <v-main>
      <table-page :headers="headers" :items="unitOfMeasurementTypes" />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getUnitOfMeasurementTypes"]),
  },
  created() {
    this.$store.commit("setSearchTerm", "");
    this.getUnitOfMeasurementTypes();
  },
  computed: {
    ...mapGetters(["currentInstitution", "unitOfMeasurementTypes"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "QuantitySymbol", value: "quantitySymbol" },
        { text: "DimensionSymbol", value: "dimensionSymbol" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>